import React, { FormEventHandler, useState } from "react";
import { userbase } from "../utils/userbase";
import { useUpdateAtom } from "jotai/utils";
import { userAtom } from "../utils/state";
import {
  EuiButton,
  EuiButtonEmpty,
  EuiCallOut,
  EuiFieldPassword,
  EuiFieldText,
  EuiFormRow,
  EuiModal,
  EuiModalBody,
  EuiModalFooter,
  EuiModalHeader,
  EuiSpacer,
  EuiTitle,
} from "@elastic/eui";

interface SignInModalProps {
  open: boolean;
  onClose: () => void;
}

const SignInModal: React.FC<SignInModalProps> = ({ open, onClose }) => {
  const [error, setError] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const setUser = useUpdateAtom(userAtom);

  const login: FormEventHandler = async (evt) => {
    evt.preventDefault();
    setLoading(true);
    setError("");
    try {
      const user = await userbase.signIn({
        username,
        password,
        rememberMe: "local",
      });
      setUser({ user });
      onClose();
    } catch (err) {
      setError(err.message);
    }
    setLoading(false);
  };

  const forgotPassword = async () => {
    if (!username) {
      setError("Username required to set password");
    } else {
      try {
        const msg = await userbase.forgotPassword({ username });
        console.log(msg);
      } catch (err) {
        setError(err.message);
      }
    }
  };

  return open ? (
    <EuiModal onClose={onClose}>
      <EuiModalHeader>
        <EuiTitle>
          <h2>Sign In</h2>
        </EuiTitle>
      </EuiModalHeader>
      <form onSubmit={login}>
        <EuiModalBody>
          {error && (
            <>
              <EuiCallOut
                color="danger"
                iconType="alert"
                title="Error signing in"
              >
                {error}
              </EuiCallOut>
              <EuiSpacer />
            </>
          )}
          <EuiFormRow label="Username">
            <EuiFieldText
              onChange={(evt) => setUsername((evt.target as any).value)}
              value={username}
            />
          </EuiFormRow>
          <EuiFormRow label="Password">
            <EuiFieldPassword
              onChange={(evt) => setPassword((evt.target as any).value)}
              value={password}
            />
          </EuiFormRow>
        </EuiModalBody>
        <EuiModalFooter>
          <EuiButtonEmpty onClick={onClose} type="button">
            Cancel
          </EuiButtonEmpty>
          <EuiButtonEmpty onClick={forgotPassword} type="button">
            Forgot Password
          </EuiButtonEmpty>
          <EuiButton isLoading={loading} type="submit">
            Login
          </EuiButton>
        </EuiModalFooter>
      </form>
    </EuiModal>
  ) : null;
};

export default SignInModal;
